import { StyleSheet } from 'aphrodite';
import { header } from '../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	addonsGrid: {
		display: 'grid',
		gap: 12,
		gridTemplateColumns: 'repeat(2, 1fr)',
		marginTop: 12,
	},
	buttonRow: {
		display: 'flex',
		gap: 12,
		justifyContent: 'flex-end',
		marginTop: 24,
	},
	checkboxLabel: {
		color: header,
		fontSize: 14,
	},
	container: {
		maxHeight: '80vh',
		maxWidth: 700,
		overflowY: 'auto',
		padding: 24,
	},
	downloadButtons: {
		display: 'flex',
		gap: 12,
		justifyContent: 'center',
		marginTop: 16,
	},
	fileName: {
		color: header,
		fontSize: 14,
		marginTop: 8,
		textAlign: 'center',
	},
	formGroup: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 16,
	},
	formRow: {
		display: 'grid',
		gap: 16,
		gridTemplateColumns: 'repeat(2, 1fr)',
		marginBottom: 16,
	},
	formSection: {
		marginTop: 24,
	},
	input: {
		border: '1px solid #D3DBDE',
		borderRadius: 4,
		fontSize: 14,
		padding: '8px 12px',
	},
	label: {
		color: header,
		fontSize: 14,
		fontWeight: 'bold',
		marginBottom: 8,
	},
	proposalTypeSection: {
		display: 'flex',
		gap: 24,
		marginTop: 16,
	},
	radioLabel: {
		alignItems: 'center',
		color: header,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		gap: 8,
	},
	sectionTitle: {
		color: header,
		fontSize: 16,
		fontWeight: 'bold',
		marginBottom: 16,
	},
	select: {
		border: '1px solid #D3DBDE',
		borderRadius: 4,
		fontSize: 14,
		padding: '8px 12px',
	},
	successSection: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		marginTop: 24,
		textAlign: 'center',
	},
	successTitle: {
		color: '#4caf50',
		fontSize: 18,
		fontWeight: 'bold',
		marginTop: 0,
	},
	title: {
		color: header,
		fontSize: 20,
		fontWeight: 'bold',
		marginTop: 0,
	},
});
